// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import axios from 'axios';

/**
 * Auth API for pre-authentication flows (registration).
 *
 * Note: This API intentionally uses a separate axios instance without
 * the silent token refresh interceptor because these endpoints are
 * called before the user is authenticated. The silent refresh logic
 * in advisorApi would cause unnecessary refresh attempts for these
 * unauthenticated requests.
 */
const authAxios = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authApi = {
  /**
   * Validate registration token.
   * Called before user is authenticated (during advisor registration flow).
   */
  validateRegistrationToken: async (token: string) => {
    const response = await authAxios.get(`/registration/validate-token`, {
      params: { token },
    });
    return response.data;
  },

  /**
   * Complete registration after password is set.
   * Called before user is authenticated (during advisor registration flow).
   */
  completeRegistration: async (token: string) => {
    const response = await authAxios.post(`/registration/complete`, { token });
    return response.data;
  },
};
